import RepBoxeLogo from '../../images/repLogo.png';

export function Header() {
  return (
    <header className='card' id='home'>
      <div className='header-logo-container'>
        <img src={RepBoxeLogo} className='header-logo' alt="logo da República do Boxe, silhueta de dois lutadores sobre o mapa do Brasil" />
        <input type='checkbox' className='checkbox-menu' id='checkbox-menu'/>
        <ul className='header-menu'>
          <li><a href='#home'>Início</a></li>
          <li><a href='#gallery'>Galeria</a></li>
          <li><a href='#schedule'>Horários</a></li>
          <li><a href='#faq'>Perguntas Frequentes</a></li>
          <li><a href='#mission'>Missão</a></li>
          <li><a href='#contact'>Fale Conosco</a></li>
        </ul>
        <label htmlFor='checkbox-menu' className="img-menu">
          <span></span>
          <span></span>
          <span></span>
        </label>
      </div>
      <div className='header-title'>
        <h1>República do Boxe</h1>
        <h2>Academia de boxe em Santos com foco no ensino e prática da nobre arte.</h2>
      </div>
    </header>
  );
}